import React, { PropTypes } from 'react'
import { Link } from 'react-router'

import './RescheduleConfirm.scss'
import RescheduleConfirmNavBar from './components/RescheduleConfirmNavBar'
import ServiceModificationPenalty from 'components/ServiceModificationPenalty'
import ServiceDetails from './components/ServiceDetails'
import ModifyingServiceLoader from 'components/ModifyingServiceLoader'
import * as paths from 'utils/paths'

class RescheduleConfirm extends React.Component {
  constructor (props) {
    super(props)

    this.onSubmit = this.onSubmit.bind(this)
    this.setPenaltyFetched = this.setPenaltyFetched.bind(this)

    this.state = {
      penaltyFetched: false
    }
  }

  componentDidMount () {
    const { serviceId, serviceModifications: { aliadaId, estimatedHours } } = this.props

    this.fetchService(serviceId)
    this.fetchAliada(aliadaId, { estimatedHours })
  }

  fetchService (id) {
    const { fetchService } = this.props
    fetchService(id)
  }

  fetchAliada (id, filters = {}) {
    const { fetchAliada } = this.props
    fetchAliada(id, filters)
  }

  setPenaltyFetched () {
    this.setState({
      penaltyFetched: true
    })
  }

  isLoading () {
    const { fetchingService, service, aliada } = this.props
    return fetchingService || !service || !aliada
  }

  onSubmit () {
    const {
      updateService,
      service,
      serviceModifications,
      params: {
        userId
      }
    } = this.props
    const next = paths.userNextServices(userId)
    updateService(service.id, serviceModifications, next)
  }

  render () {
    const loading = this.isLoading()

    const {
      service,
      serviceModifications,
      beforeRescheduleServiceDetails,
      afterRescheduleServiceDetails,
      updatingService,
      params: {
        userId
      }
    } = this.props

    const { penaltyFetched } = this.state

    const confirmButtonDisabled = !penaltyFetched || updatingService

    return (
      <div className='RescheduleConfirm navbar-screen'>
        <RescheduleConfirmNavBar />
        <ModifyingServiceLoader
          isOpen={updatingService}
          text='Reagendando tu servicio...'
          />

        {!loading &&
          <div className='RescheduleConfirm-content navbar-screen-content'>
            <div className='RescheduleConfirm-contentCard'>
              <div className='RescheduleConfirm-cardTitle'>
                Confirmar Cambios
              </div>
              <div className='RescheduleConfirm-cardBody'>
                <p>Se realizarán los siguientes cambios.</p>

                <div className='RescheduleConfirm-before'>
                  <p>Antes</p>
                  <ServiceDetails {...beforeRescheduleServiceDetails} />
                </div>

                <div className='RescheduleConfirm-after'>
                  <p>Ahora</p>
                  <ServiceDetails {...afterRescheduleServiceDetails} />
                </div>

                <ServiceModificationPenalty
                  serviceId={service.id}
                  serviceModifications={serviceModifications}
                  onPenaltyFetched={this.setPenaltyFetched}
                  />

                <p>¿Estás seguro de que quieres realizar estos cambios?</p>
              </div>
              <div className='RescheduleConfirm-buttons'>
                <Link
                  className='RescheduleConfirm-cancelBtn btn btn-default btn-lg btn-block'
                  to={paths.userModifyService(userId, service.id)}
                  >
                  Cancelar cambios
                </Link>
                <button
                  className='RescheduleConfirm-confirmBtn btn btn-primary btn-lg btn-block'
                  onClick={this.onSubmit}
                  disabled={confirmButtonDisabled}
                  >
                  Confirmar
                </button>
              </div>
            </div>
          </div>
        }
      </div>
    )
  }
}

RescheduleConfirm.displayName = 'RescheduleConfirm'
RescheduleConfirm.propTypes = {}
RescheduleConfirm.defaultProps = {}

export default RescheduleConfirm



// WEBPACK FOOTER //
// ./src/screens/App/screens/Services/screens/RescheduleConfirm/RescheduleConfirm.js